import React, { MouseEventHandler, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Icon } from '../../icons/Icon';
import styles from './AccordionField.module.scss';

export const AccordionField = ({
    children, onClick, active
}: Props) => {

    const { t } = useTranslation();
    const classes = classNames(styles.container, {
        [styles.active]: active,
        'idt-active-toggleable': active,
        'idt-inactive': !active
    });

    return (
        <div onClick={onClick} className={classes}
            title={active ? t('accordion.hide') : t('accordion.show')}>

            <div className={styles.default}>
                <div className={styles.field}>
                    {children}
                </div>

                <Icon className={styles.icon} type={active ? 'general-ui-minus' : 'general-ui-plus'} />
            </div>
        </div>
    );
};

type Props = PropsWithChildren<{
    onClick: MouseEventHandler;
    active: boolean;
}>;